import { useEffect } from 'react';
import { useRole } from '../context/roleContext';
import { useNavigate } from 'react-router-dom';

const RouterPainel = () => {
  const { role, loading } = useRole();
  const navigate = useNavigate();

  useEffect(() => {
    //console.log("chegou aqui3");

    if (loading) return;
    //console.log("chegou aqui4");
    if (role === 'admin') {
      navigate('/admin');
    } else if (role === 'support') {
      navigate('/suporte');
    } else {
      navigate('/user-area');
    }
  }, [role, loading, navigate]);

  return <div>Redirecionando...</div>;
};

export default RouterPainel;